import decode from "./decode";
import { LoginAppData } from "@/contexts/Auth";
const getLoginPasswordInfo = async (): Promise<LoginAppData | null> => {
    const loginDataLocal = localStorage.getItem("appConfig");
    console.log("🚀 ~ getLoginPasswordInfo ~ loginDataLocal:", loginDataLocal);
    if (!loginDataLocal) {
        return null;
    }
    const loginData = await decode({ encodedText: loginDataLocal });
    if (!loginData) {
        return null;
    }
    return loginData;
};
export default getLoginPasswordInfo;
